import { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import ConfirmBankPayment from "../../shared/ConfirmBankPayment";

const EapConfirmBankPayment = () => {
  const navigate = useNavigate();
  const { customer, methodStepData, paymentParameters, contactId } =
    useOutletContext();

  useEffect(() => {
    if (!methodStepData || !methodStepData.institution) {
      navigate(`/embeddedaccountpayment?cu=${contactId}`);
    }
  }, []);

  return (
    methodStepData &&
    methodStepData.institution && (
      <ConfirmBankPayment
        institution={methodStepData.institution}
        merchant={customer.merchant}
        paymentParameters={paymentParameters}
        flowType="poll"
        returnUrl={`/embeddedaccountpayment/choosemethod?cu=${contactId}`}
        processingUrl={`/embeddedaccountpayment/processing?cu=${contactId}`}
        successUrl={`/embeddedaccountpayment/processing?cu=${contactId}`}
        failedUrl={`/embeddedaccountpayment/paymentfailed?cu=${contactId}`}
      />
    )
  );
};
export default EapConfirmBankPayment;
